import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Services.css';

const Services = () => {
  const [activeService, setActiveService] = useState('implants');

  const services = {
    implants: {
      title: "Implants",
      subtitle: "Permanent Tooth Replacement Solutions",
      description: "Advanced implant dentistry including placement, repairs, and supporting procedures for lasting results.",
      treatments: [
        {
          name: "Dental Implants",
          description: "Permanent tooth replacement with titanium implants",
          duration: "3-6 months",
          slug: "dental-implants",
          icon: "M12 2l3.09 6.26L22 9l-5.09.74L16 16l-1.09-6.26L8 9l6.91-.74L12 2z"
        },
        {
          name: "Implant Repairs",
          description: "Professional repair and maintenance of existing implants",
          duration: "1-2 visits",
          slug: "implant-repairs",
          icon: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.58L19 8l-9 9z"
        },
        {
          name: "Bone Graft & Sinus Lift",
          description: "Artificial bone grafting and maxillary sinus lift procedures",
          duration: "2-4 visits",
          slug: "bone-graft-sinus-lift",
          icon: "M9 11H7v2h2v-2zm4 0h-2v2h2v-2zm4 0h-2v2h2v-2zm2-7h-1V2h-2v2H8V2H6v2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H5V9h14v11z"
        }
      ]
    },
    orthodontics: {
      title: "Orthodontics",
      subtitle: "Straighten Your Teeth with Expert Care",
      description: "Professional orthodontic treatments to correct misaligned teeth and improve your bite for a perfect smile.",
      treatments: [
        {
          name: "Braces",
          description: "Traditional and modern braces for comprehensive teeth straightening",
          duration: "18-24 months",
          slug: "orthodontics",
          icon: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.58L19 8l-9 9z"
        }
      ]
    },
    cosmetic: {
      title: "Cosmetic Dentistry",
      subtitle: "Enhance Your Natural Beauty",
      description: "Comprehensive cosmetic treatments to improve the appearance and function of your teeth.",
      treatments: [
        {
          name: "Cosmetic Treatments",
          description: "Complete smile makeovers and aesthetic improvements",
          duration: "2-4 visits",
          slug: "cosmetic-dentistry",
          icon: "M12 2l3.09 6.26L22 9l-5.09.74L16 16l-1.09-6.26L8 9l6.91-.74L12 2z"
        },
        {
          name: "Composite Restoration",
          description: "Tooth-colored fillings and restorations for natural appearance",
          duration: "1-2 visits",
          slug: "composite-restoration",
          icon: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.58L19 8l-9 9z"
        },
        {
          name: "PFM & Zirconia Crowns",
          description: "High-quality porcelain-fused-metal and zirconia crowns",
          duration: "2-3 visits",
          slug: "crowns",
          icon: "M9 11H7v2h2v-2zm4 0h-2v2h2v-2zm4 0h-2v2h2v-2zm2-7h-1V2h-2v2H8V2H6v2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H5V9h14v11z"
        },
        {
          name: "Partial & Complete Dentures",
          description: "Custom-made dentures for missing teeth replacement",
          duration: "4-6 weeks",
          slug: "dentures",
          icon: "M12 2l3.09 6.26L22 9l-5.09.74L16 16l-1.09-6.26L8 9l6.91-.74L12 2z"
        }
      ]
    },
    restorative: {
      title: "Restorative Dentistry",
      subtitle: "Restore Function and Health",
      description: "Advanced restorative treatments to save and repair damaged teeth and restore oral health.",
      treatments: [
        {
          name: "Root Canal Treatment (RCT)",
          description: "Advanced endodontic treatment to save infected teeth",
          duration: "2-3 visits",
          slug: "root-canal-treatment",
          icon: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.58L19 8l-9 9z"
        },
        {
          name: "Simple & Surgical Extractions",
          description: "Professional tooth extractions with minimal discomfort",
          duration: "1 visit",
          slug: "extractions",
          icon: "M12 2l3.09 6.26L22 9l-5.09.74L16 16l-1.09-6.26L8 9l6.91-.74L12 2z"
        },
        {
          name: "Impactions & Apicectomies",
          description: "Surgical removal of impacted teeth and root-end surgeries",
          duration: "1-2 visits",
          slug: "surgical-procedures",
          icon: "M9 11H7v2h2v-2zm4 0h-2v2h2v-2zm4 0h-2v2h2v-2zm2-7h-1V2h-2v2H8V2H6v2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H5V9h14v11z"
        }
      ]
    },
    periodontics: {
      title: "Periodontics (Gum Treatment)",
      subtitle: "Specialized Gum Care",
      description: "Professional periodontal therapy to treat gum disease and maintain healthy gums.",
      treatments: [
        {
          name: "Scaling & Root Planning (SRP)",
          description: "Deep cleaning procedure to treat gum disease and infection",
          duration: "2-4 visits",
          slug: "scaling-root-planning",
          icon: "M12 2l3.09 6.26L22 9l-5.09.74L16 16l-1.09-6.26L8 9l6.91-.74L12 2z"
        }
      ]
    },
    surgery: {
      title: "Oral & Maxillofacial Surgery",
      subtitle: "Advanced Surgical Procedures",
      description: "Specialized surgical treatments for complex oral and facial conditions.",
      treatments: [
        {
          name: "Soft Tissue Surgeries",
          description: "Surgical procedures involving oral soft tissues",
          duration: "1-2 visits",
          slug: "soft-tissue-surgery",
          icon: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.58L19 8l-9 9z"
        },
        {
          name: "Tongue Tie Treatment",
          description: "Surgical correction of tongue tie (ankyloglossia)",
          duration: "1 visit",
          slug: "tongue-tie-treatment",
          icon: "M12 2l3.09 6.26L22 9l-5.09.74L16 16l-1.09-6.26L8 9l6.91-.74L12 2z"
        },
        {
          name: "Biopsies",
          description: "Tissue sampling for diagnostic purposes",
          duration: "1 visit",
          slug: "biopsies",
          icon: "M9 11H7v2h2v-2zm4 0h-2v2h2v-2zm4 0h-2v2h2v-2zm2-7h-1V2h-2v2H8V2H6v2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H5V9h14v11z"
        },
        {
          name: "Mole & Wart Removal",
          description: "Safe removal of oral moles and warts",
          duration: "1 visit",
          slug: "mole-wart-removal",
          icon: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.58L19 8l-9 9z"
        }
      ]
    },
    tmj: {
      title: "TMJ & Jaw Disorders",
      subtitle: "Jaw Pain Relief",
      description: "Specialized treatment for temporomandibular joint disorders and jaw-related problems.",
      treatments: [
        {
          name: "TMJ Disorders Treatment",
          description: "Comprehensive treatment for jaw joint disorders and pain",
          duration: "Multiple visits",
          slug: "tmj-treatment",
          icon: "M12 2l3.09 6.26L22 9l-5.09.74L16 16l-1.09-6.26L8 9l6.91-.74L12 2z"
        }
      ]
    },
    anesthesia: {
      title: "Anesthesia & Sedation Services",
      subtitle: "Comfortable Treatment Experience",
      description: "Advanced anesthesia and sedation options for comfortable dental procedures.",
      treatments: [
        {
          name: "Conscious Sedation",
          description: "Safe sedation to help you relax during procedures",
          duration: "As needed",
          slug: "conscious-sedation",
          icon: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.58L19 8l-9 9z"
        },
        {
          name: "Anesthesiologist Services",
          description: "Professional anesthesiologist available for complex procedures",
          duration: "As needed",
          slug: "anesthesiologist-services",
          icon: "M9 11H7v2h2v-2zm4 0h-2v2h2v-2zm4 0h-2v2h2v-2zm2-7h-1V2h-2v2H8V2H6v2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H5V9h14v11z"
        }
      ]
    }
  };

  return (
    <section className="services-section" id="services">
      <div className="services-container">
        {/* Header */}
        <div className="services-header">
          <div className="services-badge">
            <svg className="badge-icon" viewBox="0 0 24 24" fill="currentColor">
              <path d="M12 2L13.09 8.26L22 9L13.09 9.74L12 16L10.91 9.74L2 9L10.91 8.26L12 2Z"/>
            </svg>
            <span>Comprehensive Dental Care</span>
          </div>
          
          <h2 className="services-title">
            Comprehensive Dental Care at
            <span className="title-highlight"> Prime Care Dental</span>
          </h2>
          
          <p className="services-description">
            We provide a complete range of dental services using the latest technology and techniques. 
            From routine cleanings to complex procedures, our experienced team is here to help you achieve optimal oral health.
          </p>
        </div>

        {/* Service Categories */}
        <div className="service-categories">
          {Object.keys(services).map((key) => (
            <button
              key={key}
              className={`category-btn ${activeService === key ? 'active' : ''}`}
              onClick={() => setActiveService(key)}
            >
              {services[key].title}
            </button>
          ))}
        </div>

        {/* Active Service Content */}
        <div className="service-content">
          <div className="service-info">
            <h3 className="service-title">{services[activeService].title}</h3>
            <h4 className="service-subtitle">{services[activeService].subtitle}</h4>
            <p className="service-desc">{services[activeService].description}</p>
            <div className="service-actions">
              <Link to={`/service/${activeService}`} className="service-detail-btn">
                View Complete Details
                <svg viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8-8-8z"/>
                </svg>
              </Link>
            </div>
          </div>

          <div className="treatments-grid">
            {services[activeService].treatments.map((treatment, index) => (
              <div key={index} className="treatment-card">
                <div className="treatment-icon">
                  <svg viewBox="0 0 24 24" fill="currentColor">
                    <path d={treatment.icon}/>
                  </svg>
                </div>
                
                <div className="treatment-content">
                  <h5 className="treatment-name">{treatment.name}</h5>
                  <p className="treatment-desc">{treatment.description}</p>
                  
                  <div className="treatment-meta">
                    <div className="treatment-duration">
                      <svg className="duration-icon" viewBox="0 0 24 24" fill="currentColor">
                        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm3.5 6L12 10.5 8.5 8 7 9.5l5 5 5-5-1.5-1.5z"/>
                      </svg>
                      <span>Duration: {treatment.duration}</span>
                    </div>
                    <Link to={`/service/${treatment.slug}`} className="treatment-link">
                      <svg viewBox="0 0 24 24" fill="currentColor">
                        <path d="M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8-8-8z"/>
                      </svg>
                      Learn More
                    </Link>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Background Elements */}
        <div className="services-bg-elements">
          <div className="bg-circle circle-1"></div>
          <div className="bg-circle circle-2"></div>
          <div className="bg-circle circle-3"></div>
        </div>
      </div>
    </section>
  );
};

export default Services;